import MessageRow from '../MessageRow/MessageRow'
import { HomeMessage, MessageLabels, SectionView } from '../types'
import { EmptyState, Grid } from './styled-components'

interface SectionBodyProps {
  noResultsText: string
  view: SectionView
  labels: MessageLabels
  onToggle: (message: HomeMessage) => void
}

const SectionBody = ({ noResultsText, view, labels, onToggle }: SectionBodyProps) => {
  if (view.hasNoResults) return <EmptyState>{noResultsText}</EmptyState>

  return (
    <Grid>
      {view.rows.map(row => (
        <MessageRow key={row.key} row={row} labels={labels} onToggle={onToggle} />
      ))}
    </Grid>
  )
}

export default SectionBody
